export const mappingTypesToTariffs = {
  'Электричество общее': 'Электричество',
  'Холодная вода': 'Вода',
  'Горячая вода': 'Горячая вода',
  'Газ обычный': 'Газ',
  'Водоотведение': 'Водоотведение',
  'Отопление': 'Отопление',
  'Отопление МОП': 'Отопление МОП'
};

export const meterReadingInputs = [
  {
    id: 2,
    name: 'dayReading',
    title: 'День',
  },
  {
    id: 3,
    name: 'nightReading',
    title: 'Ночь',
  },
  {
    id: 1,
    name: 'generalReading',
    title: 'Общее',
  },
];
